import React, { FC, ReactNode } from 'react';

const PriceBeforeDiscount: FC<{ children?: ReactNode }> = ({ children }) => (
  <span className="Offer-Price-Before-Discount ml-4 text-grey-2 font-normal text-md line-through md:inline-block">
    {children}
  </span>
);

export default PriceBeforeDiscount;
